import React from "react";
import { Pager as KendoPager } from '@progress/kendo-react-data-tools';
import {useEffect, useState} from "react";

export const Pager = ({ref, ...props}) => {
    const {
        pageSizes = [5, 10, 20, 50, 100, 200],
        skip = 0,
        take = 20,
        buttonCount = 5,
        type = 'numeric',
        info = true,
        previousNext = true,
        responsive = true,
        adaptive = true,
        total,
    } = props;

    const [pageState, setPageState] = useState({
        skip, // skip
        take, // take
        buttonCount,
        type,
        info,
        pageSizes,
        previousNext,
        responsive,
        adaptive,
    });

    const handlePageChange = async event => {
        const { skip, take } = event;
        await setPageState({
            ...pageState,
            skip: skip,
            take: take,
        });
    };

    const reload = () => {
        const resetState = {
            ...pageState,
            skip: 0,
        };
        setPageState(resetState);
    };

    // Assign reload to ref if one is supplied.
    useEffect(() => {
        if (ref) {
            if (typeof ref === 'function') {
                ref({ reload });
            } else {
                ref.current = { reload };
            }
        }
    });

    // will reload on page internal state change.
    // if you need to reload on external state change, use a ref.
    useEffect(() => {
        props.onChange(pageState)
    }, [pageState]);

    return (
        <KendoPager
            skip={pageState.skip}
            take={pageState.take}
            total={total}
            buttonCount={pageState.buttonCount}
            info={pageState.info}
            type={pageState.type}
            pageSizes={pageState.pageSizes}
            previousNext={pageState.previousNext}
            responsive={pageState.responsive}
            adaptive={pageState.adaptive}
            onPageChange={handlePageChange}
        />
    )

};
